"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGasPriceProvider = void 0;
/**
 * Provider for getting gas prices.
 */
class IGasPriceProvider {
}
exports.IGasPriceProvider = IGasPriceProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2FzLXByaWNlLXByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9nYXMtcHJpY2UtcHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBTUE7O0dBRUc7QUFDSCxNQUFzQixpQkFBaUI7Q0FFdEM7QUFGRCw4Q0FFQyJ9